/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IntlMessageComponent from 'components/formatters/intlMessage';

type LoadingDialogComponentProps = {
  titleId?: ?string,
  bodyId?: string,
  closeDialog: () => void,
};

export default function LoadingDialogComponent({
  titleId,
  bodyId = 'general.loading',
  closeDialog,
}: LoadingDialogComponentProps) {
  return (
    <Dialog open onClose={closeDialog}>
      {titleId ? (
        <DialogTitle>
          <IntlMessageComponent id={titleId} />
        </DialogTitle>
      ) : null}

      <DialogContent>
        <Box align="center" p={5}>
          <Box><CircularProgress size={60} /></Box>
          <strong><IntlMessageComponent id={bodyId} /></strong>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
